var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyConversationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_160740",
    "data-name": "Group 160740",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 344.5,
    height: 256.728,
    viewBox: "0 0 344.5 256.728",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1943",
    "data-name": "Rectangle 1943",
    width: 344.5,
    height: 256.728,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1924",
    "data-name": "Rectangle 1924",
    width: 48.676,
    height: 98.391,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1925",
    "data-name": "Rectangle 1925",
    width: 37.528,
    height: 36.598,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-7"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1926",
    "data-name": "Rectangle 1926",
    width: 26.738,
    height: 26.076,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-8"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1927",
    "data-name": "Rectangle 1927",
    width: 3.889,
    height: 3.885,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-11"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1930",
    "data-name": "Rectangle 1930",
    width: 4.212,
    height: 6.117,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-13"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1932",
    "data-name": "Rectangle 1932",
    width: 28.618,
    height: 4.013,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-14"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1933",
    "data-name": "Rectangle 1933",
    width: 28.619,
    height: 4.013,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-15"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1934",
    "data-name": "Rectangle 1934",
    width: 5.259,
    height: 28.614,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2240",
    "data-name": "Path 2240",
    d: "M116.54,84.057Z",
    transform: "translate(-116.54 -84.057)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-18"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1936",
    "data-name": "Rectangle 1936",
    width: 5.959,
    height: 13.615,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-19"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1937",
    "data-name": "Rectangle 1937",
    width: 4.551,
    height: 13.332,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-20"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1938",
    "data-name": "Rectangle 1938",
    width: 41.569,
    height: 11.457,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-21"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1939",
    "data-name": "Rectangle 1939",
    width: 35.955,
    height: 127.702,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-22"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1940",
    "data-name": "Rectangle 1940",
    width: 6.798,
    height: 41.755,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-23"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1941",
    "data-name": "Rectangle 1941",
    width: 21.489,
    height: 130.978,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_160739",
    "data-name": "Group 160739",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1899",
    "data-name": "Rectangle 1899",
    width: 344.5,
    height: 0.172,
    transform: "translate(0 225.61)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1900",
    "data-name": "Rectangle 1900",
    width: 50.841,
    height: 0.172,
    transform: "translate(229.666 230.302)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1901",
    "data-name": "Rectangle 1901",
    width: 5.989,
    height: 0.172,
    transform: "translate(71.391 231.46)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1902",
    "data-name": "Rectangle 1902",
    width: 13.224,
    height: 0.172,
    transform: "translate(281.197 236.7)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1903",
    "data-name": "Rectangle 1903",
    width: 33.532,
    height: 0.172,
    transform: "translate(137.8 234.37)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1904",
    "data-name": "Rectangle 1904",
    width: 16.797,
    height: 0.172,
    transform: "translate(114.869 234.37)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1905",
    "data-name": "Rectangle 1905",
    width: 22.838,
    height: 0.172,
    transform: "translate(36.144 231.46)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160678",
    "data-name": "Group 160678"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160677",
    "data-name": "Group 160677",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2201",
    "data-name": "Path 2201",
    d: "M175.185,194.882H42.14a3.937,3.937,0,0,1-3.933-3.933V3.933A3.938,3.938,0,0,1,42.14,0H175.185a3.937,3.937,0,0,1,3.932,3.933V190.949a3.937,3.937,0,0,1-3.932,3.933M42.14.172a3.764,3.764,0,0,0-3.761,3.761V190.949a3.764,3.764,0,0,0,3.761,3.761H175.185a3.765,3.765,0,0,0,3.76-3.761V3.933a3.765,3.765,0,0,0-3.76-3.761Z",
    transform: "translate(-11.882)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2202",
    "data-name": "Path 2202",
    d: "M391.482,194.882H258.437a3.937,3.937,0,0,1-3.932-3.933V3.933A3.937,3.937,0,0,1,258.437,0H391.482a3.938,3.938,0,0,1,3.933,3.933V190.949a3.937,3.937,0,0,1-3.933,3.933M258.437.172a3.764,3.764,0,0,0-3.76,3.761V190.949a3.764,3.764,0,0,0,3.76,3.761H391.482a3.765,3.765,0,0,0,3.761-3.761V3.933A3.765,3.765,0,0,0,391.482.172Z",
    transform: "translate(-79.151)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1906",
    "data-name": "Rectangle 1906",
    width: 106.096,
    height: 124.322,
    transform: "translate(52.367 27.378)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1907",
    "data-name": "Rectangle 1907",
    width: 106.096,
    height: 124.322,
    transform: "translate(50.005 27.378)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1908",
    "data-name": "Rectangle 1908",
    width: 106.096,
    height: 4.025,
    transform: "translate(52.367 151.7)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1909",
    "data-name": "Rectangle 1909",
    width: 106.096,
    height: 4.025,
    transform: "translate(45.765 151.7)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1910",
    "data-name": "Rectangle 1910",
    width: 97.615,
    height: 116.403,
    transform: "translate(54.246 31.338)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2203",
    "data-name": "Path 2203",
    d: "M186.875,161.885l-16.741-116.4H143.414l16.741,116.4Z",
    transform: "translate(-44.602 -14.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2204",
    "data-name": "Path 2204",
    d: "M142.8,161.885l-16.741-116.4h-18.4l16.741,116.4Z",
    transform: "translate(-33.483 -14.145)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1911",
    "data-name": "Rectangle 1911",
    width: 1.786,
    height: 116.403,
    transform: "translate(54.246 31.338)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1912",
    "data-name": "Rectangle 1912",
    width: 102.588,
    height: 5.316,
    transform: "translate(51.759 131.469)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1913",
    "data-name": "Rectangle 1913",
    width: 16.371,
    height: 164.027,
    transform: "translate(198.24 61.584)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2205",
    "data-name": "Path 2205",
    d: "M290.83,323.454h-3.109v-8.845h6.37Z",
    transform: "translate(-89.481 -97.843)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1914",
    "data-name": "Rectangle 1914",
    width: 16.371,
    height: 164.027,
    transform: "translate(280.528 61.584)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1915",
    "data-name": "Rectangle 1915",
    width: 85.001,
    height: 159.672,
    transform: "translate(198.24 61.584)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2206",
    "data-name": "Path 2206",
    d: "M327.226,238.286H293.937a3.242,3.242,0,0,1-3.238-3.239V95.841a3.242,3.242,0,0,1,3.238-3.239h33.288a3.243,3.243,0,0,1,3.24,3.239V235.047a3.242,3.242,0,0,1-3.24,3.239M293.937,93.323a2.52,2.52,0,0,0-2.517,2.518V235.047a2.52,2.52,0,0,0,2.517,2.518h33.288a2.521,2.521,0,0,0,2.518-2.518V95.841a2.521,2.521,0,0,0-2.518-2.518Z",
    transform: "translate(-90.407 -28.799)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2207",
    "data-name": "Path 2207",
    d: "M386.924,238.286H353.635a3.242,3.242,0,0,1-3.238-3.239V95.841a3.242,3.242,0,0,1,3.238-3.239h33.288a3.243,3.243,0,0,1,3.24,3.239V235.047a3.243,3.243,0,0,1-3.24,3.239M353.635,93.323a2.52,2.52,0,0,0-2.517,2.518V235.047a2.52,2.52,0,0,0,2.517,2.518h33.288a2.521,2.521,0,0,0,2.518-2.518V95.841a2.521,2.521,0,0,0-2.518-2.518Z",
    transform: "translate(-108.973 -28.799)",
    fill: "#e0e0e0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2208",
    "data-name": "Path 2208",
    d: "M361.1,197.811a2.764,2.764,0,1,1-2.764-2.764,2.764,2.764,0,0,1,2.764,2.764",
    transform: "translate(-110.583 -60.66)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2209",
    "data-name": "Path 2209",
    d: "M340.744,197.811a2.764,2.764,0,1,1-2.764-2.764,2.764,2.764,0,0,1,2.764,2.764",
    transform: "translate(-104.252 -60.66)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2210",
    "data-name": "Path 2210",
    d: "M405.106,323.454h3.109v-8.845h-6.37Z",
    transform: "translate(-124.974 -97.843)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2211",
    "data-name": "Path 2211",
    d: "M352.737,53.491H326.658L337.529,49.8h26.079Z",
    transform: "translate(-101.591 -15.487)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1916",
    "data-name": "Rectangle 1916",
    width: 26.079,
    height: 23.579,
    transform: "translate(257.374 38.005)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1917",
    "data-name": "Rectangle 1917",
    width: 6.969,
    height: 11.336,
    transform: "translate(220.686 50.247)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1918",
    "data-name": "Rectangle 1918",
    width: 8.633,
    height: 11.336,
    transform: "translate(212.053 50.247)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2212",
    "data-name": "Path 2212",
    d: "M368.64,54.053h26.079L383.848,51.6H357.769Z",
    transform: "translate(-111.266 -16.048)",
    fill: "#ebebeb"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1919",
    "data-name": "Rectangle 1919",
    width: 32.307,
    height: 23.579,
    transform: "translate(225.067 38.005)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2213",
    "data-name": "Path 2213",
    d: "M177.891,303.154h22.366l-2.64-53.817H177.891Z",
    transform: "translate(-55.324 -77.544)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2214",
    "data-name": "Path 2214",
    d: "M75.236,302.338h85.882l5.936-55.624H81.172Z",
    transform: "translate(-23.398 -76.728)",
    fill: "#e6e6e6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2215",
    "data-name": "Path 2215",
    d: "M71.627,302.338H157.51l5.936-55.624H77.563Z",
    transform: "translate(-22.276 -76.728)",
    fill: "#f0f0f0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2216",
    "data-name": "Path 2216",
    d: "M155.527,298.96l5.429-43.309H83.647L78.217,298.96Z",
    transform: "translate(-24.326 -79.507)",
    fill: "#fafafa"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160680",
    "data-name": "Group 160680"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160679",
    "data-name": "Group 160679",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2217",
    "data-name": "Path 2217",
    d: "M323.29,357.765c0,4.309-59.81,7.8-133.59,7.8s-133.59-3.493-133.59-7.8,59.81-7.8,133.59-7.8,133.59,3.493,133.59,7.8",
    transform: "translate(-17.451 -108.838)",
    fill: "#f5f5f5"
  }))), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1922",
    "data-name": "Rectangle 1922",
    width: 16.405,
    height: 0.74,
    transform: "matrix(0.05, -0.999, 0.999, 0.05, 247.305, 90.984)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1923",
    "data-name": "Rectangle 1923",
    width: 5.914,
    height: 0.74,
    transform: "matrix(0.05, -0.999, 0.999, 0.05, 246.835, 100.289)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160715",
    "data-name": "Group 160715"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160714",
    "data-name": "Group 160714",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2218",
    "data-name": "Path 2218",
    d: "M298.428,221.692H227.994a8.8,8.8,0,0,1-8.852-9.322L227,56.655a9.944,9.944,0,0,1,9.793-9.322h70.434a8.8,8.8,0,0,1,8.852,9.322L308.22,212.37a9.944,9.944,0,0,1-9.792,9.322",
    transform: "translate(-68.149 -14.721)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160683",
    "data-name": "Group 160683",
    transform: "translate(178.824 93.777)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160682",
    "data-name": "Group 160682"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160681",
    "data-name": "Group 160681",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2219",
    "data-name": "Path 2219",
    d: "M292.039,234.5H270.8a11.178,11.178,0,0,1-11.239-11.834l3.771-74.76a12.56,12.56,0,0,1,12.392-11.8h21.243a11.18,11.18,0,0,1,11.24,11.836L304.431,222.7a12.559,12.559,0,0,1-12.392,11.8m-16.32-97.613A11.772,11.772,0,0,0,264.1,147.942L260.333,222.7A10.4,10.4,0,0,0,270.8,233.72h21.244a11.772,11.772,0,0,0,11.615-11.058l3.771-74.76a10.4,10.4,0,0,0-10.463-11.019Z",
    transform: "translate(-259.541 -136.106)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160686",
    "data-name": "Group 160686",
    transform: "translate(166.677 77.833)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160685",
    "data-name": "Group 160685"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160684",
    "data-name": "Group 160684",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2220",
    "data-name": "Path 2220",
    d: "M268.73,149.562H250.776a8.8,8.8,0,0,1-8.852-9.322l.905-17.954a9.944,9.944,0,0,1,9.792-9.322h17.954a8.8,8.8,0,0,1,8.852,9.322l-.906,17.954a9.943,9.943,0,0,1-9.792,9.322",
    transform: "translate(-241.912 -112.965)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2221",
    "data-name": "Path 2221",
    d: "M261.143,141.572H243.189a8.8,8.8,0,0,1-8.852-9.322l.905-17.954a9.943,9.943,0,0,1,9.792-9.322h17.954a8.8,8.8,0,0,1,8.852,9.322l-.906,17.954a9.943,9.943,0,0,1-9.792,9.322",
    transform: "translate(-72.875 -32.647)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160689",
    "data-name": "Group 160689",
    transform: "translate(199.605 157.811)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160688",
    "data-name": "Group 160688"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160687",
    "data-name": "Group 160687",
    clipPath: "url(#clip-path-7)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2222",
    "data-name": "Path 2222",
    d: "M308.809,255.119H296.017a6.272,6.272,0,0,1-6.307-6.642l.646-12.792a7.084,7.084,0,0,1,6.977-6.642h12.792a6.272,6.272,0,0,1,6.307,6.642l-.646,12.792a7.084,7.084,0,0,1-6.977,6.642",
    transform: "translate(-289.702 -229.043)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2223",
    "data-name": "Path 2223",
    d: "M303.4,249.426H290.611a6.272,6.272,0,0,1-6.307-6.642l.646-12.792a7.084,7.084,0,0,1,6.977-6.642h12.792a6.272,6.272,0,0,1,6.307,6.642l-.646,12.792a7.084,7.084,0,0,1-6.977,6.642",
    transform: "translate(-88.416 -69.462)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2224",
    "data-name": "Path 2224",
    d: "M243.922,196.475h-9.231a4.526,4.526,0,0,1-4.552-4.793l.466-9.231a5.113,5.113,0,0,1,5.035-4.793h9.232a4.525,4.525,0,0,1,4.551,4.793l-.465,9.231a5.113,5.113,0,0,1-5.035,4.793",
    transform: "translate(-71.571 -55.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2225",
    "data-name": "Path 2225",
    d: "M329.861,196.475H320.63a4.526,4.526,0,0,1-4.552-4.793l.466-9.231a5.113,5.113,0,0,1,5.035-4.793h9.232a4.525,4.525,0,0,1,4.551,4.793l-.465,9.231a5.113,5.113,0,0,1-5.035,4.793",
    transform: "translate(-98.298 -55.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2226",
    "data-name": "Path 2226",
    d: "M286.892,196.475h-9.231a4.526,4.526,0,0,1-4.552-4.793l.465-9.231a5.113,5.113,0,0,1,5.035-4.793h9.232a4.526,4.526,0,0,1,4.551,4.793l-.465,9.231a5.113,5.113,0,0,1-5.035,4.793",
    transform: "translate(-84.935 -55.251)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2227",
    "data-name": "Path 2227",
    d: "M310.2,81.98H242.578a4.912,4.912,0,0,1-4.94-5.2l.006-.124a5.549,5.549,0,0,1,5.465-5.2h67.624a4.913,4.913,0,0,1,4.941,5.2l-.006.124a5.55,5.55,0,0,1-5.466,5.2",
    transform: "translate(-73.903 -22.221)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2228",
    "data-name": "Path 2228",
    d: "M337.1,74.8l.862,1.946,2.132.312-1.63,1.514.259,2.138-1.87-1.009-1.971,1.009.475-2.138-1.477-1.514,2.163-.312Z",
    transform: "translate(-103.836 -23.263)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160692",
    "data-name": "Group 160692",
    transform: "translate(168.698 52.551)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160691",
    "data-name": "Group 160691"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160690",
    "data-name": "Group 160690",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2229",
    "data-name": "Path 2229",
    d: "M248.732,78.214a2.065,2.065,0,0,1-2.04,1.942,1.828,1.828,0,0,1-1.844-1.942,2.065,2.065,0,0,1,2.04-1.942,1.829,1.829,0,0,1,1.844,1.942",
    transform: "translate(-244.845 -76.272)",
    fill: "#407bff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160695",
    "data-name": "Group 160695",
    transform: "translate(173.683 52.551)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160694",
    "data-name": "Group 160694"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160693",
    "data-name": "Group 160693",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2230",
    "data-name": "Path 2230",
    d: "M255.967,78.214a2.065,2.065,0,0,1-2.04,1.942,1.828,1.828,0,0,1-1.844-1.942,2.065,2.065,0,0,1,2.04-1.942,1.828,1.828,0,0,1,1.844,1.942",
    transform: "translate(-252.08 -76.272)",
    fill: "#407bff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160698",
    "data-name": "Group 160698",
    transform: "translate(178.669 52.551)",
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160697",
    "data-name": "Group 160697"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160696",
    "data-name": "Group 160696",
    clipPath: "url(#clip-path-8)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2231",
    "data-name": "Path 2231",
    d: "M263.2,78.214a2.065,2.065,0,0,1-2.04,1.942,1.828,1.828,0,0,1-1.844-1.942,2.065,2.065,0,0,1,2.039-1.942,1.829,1.829,0,0,1,1.844,1.942",
    transform: "translate(-259.316 -76.272)",
    fill: "#407bff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160701",
    "data-name": "Group 160701",
    transform: "translate(197.219 37.938)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160700",
    "data-name": "Group 160700"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160699",
    "data-name": "Group 160699",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2232",
    "data-name": "Path 2232",
    d: "M286.239,58.121l3.9,3.058.309-6.117Z",
    transform: "translate(-286.239 -55.063)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160704",
    "data-name": "Group 160704",
    transform: "translate(205.436 37.938)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160703",
    "data-name": "Group 160703"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160702",
    "data-name": "Group 160702",
    clipPath: "url(#clip-path-11)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2233",
    "data-name": "Path 2233",
    d: "M302.377,58.121l-4.212,3.058.309-6.117Z",
    transform: "translate(-298.165 -55.063)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160707",
    "data-name": "Group 160707",
    transform: "translate(207.297 79.129)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160706",
    "data-name": "Group 160706"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160705",
    "data-name": "Group 160705",
    clipPath: "url(#clip-path-13)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2234",
    "data-name": "Path 2234",
    d: "M327.384,118.859h-24.6a1.905,1.905,0,0,1-1.914-2.017,2.124,2.124,0,0,1,2.1-2h24.6a1.9,1.9,0,0,1,1.915,2.017,2.126,2.126,0,0,1-2.1,2m-24.417-3.626a1.733,1.733,0,0,0-1.71,1.628,1.516,1.516,0,0,0,1.527,1.609h24.6a1.735,1.735,0,0,0,1.711-1.628,1.521,1.521,0,0,0-1.529-1.609Z",
    transform: "translate(-300.866 -114.846)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160710",
    "data-name": "Group 160710",
    transform: "translate(207.018 84.634)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160709",
    "data-name": "Group 160709"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160708",
    "data-name": "Group 160708",
    clipPath: "url(#clip-path-14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2235",
    "data-name": "Path 2235",
    d: "M326.98,126.85h-24.6a1.906,1.906,0,0,1-1.915-2.017,2.126,2.126,0,0,1,2.1-2h24.6a1.9,1.9,0,0,1,1.915,2.016,2.127,2.127,0,0,1-2.1,2m-24.417-3.626a1.734,1.734,0,0,0-1.711,1.628,1.517,1.517,0,0,0,1.527,1.609h24.6a1.734,1.734,0,0,0,1.711-1.628,1.52,1.52,0,0,0-1.528-1.609Z",
    transform: "translate(-300.462 -122.836)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160713",
    "data-name": "Group 160713",
    transform: "translate(164.792 153.694)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160712",
    "data-name": "Group 160712"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160711",
    "data-name": "Group 160711",
    clipPath: "url(#clip-path-15)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2236",
    "data-name": "Path 2236",
    d: "M241.093,251.682a1.905,1.905,0,0,1-1.915-2.017l1.241-24.6a2.126,2.126,0,0,1,2.1-2,1.906,1.906,0,0,1,1.915,2.017l-1.241,24.6a2.127,2.127,0,0,1-2.1,2m1.423-28.226a1.734,1.734,0,0,0-1.71,1.629l-1.241,24.6a1.517,1.517,0,0,0,1.528,1.608,1.733,1.733,0,0,0,1.71-1.629l1.241-24.6a1.516,1.516,0,0,0-1.528-1.608m-3.145,26.219h0Z",
    transform: "translate(-239.175 -223.068)",
    fill: "#fff"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_160738",
    "data-name": "Group 160738"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160737",
    "data-name": "Group 160737",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2237",
    "data-name": "Path 2237",
    d: "M146.913,152.99l3.289,2.866-6.072,2.745a31.408,31.408,0,0,1-.46-3.648,1.692,1.692,0,0,1,1.541-1.82Z",
    transform: "translate(-44.679 -47.58)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2238",
    "data-name": "Path 2238",
    d: "M151.628,162.98h-5.382l-1.908-3.085,6.072-2.745Z",
    transform: "translate(-44.889 -48.874)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160718",
    "data-name": "Group 160718",
    transform: "translate(80.296 57.915)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160717",
    "data-name": "Group 160717"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160716",
    "data-name": "Group 160716",
    clipPath: "url(#clip-path-17)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2239",
    "data-name": "Path 2239",
    d: "M116.54,84.057",
    transform: "translate(-116.54 -84.057)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2241",
    "data-name": "Path 2241",
    d: "M196.589,90.947c2.3,2.908,4.678,5.892,7.057,8.783,2.378,2.906,4.809,5.757,7.3,8.431l.943.983.358.365a3.485,3.485,0,0,0,.317.285,12.377,12.377,0,0,0,1.849,1.2,38.379,38.379,0,0,0,4.8,2.1c3.406,1.254,7.062,2.344,10.649,3.353l-.531,4.049a63.089,63.089,0,0,1-11.863-1.317,35.794,35.794,0,0,1-6.02-1.788,17.392,17.392,0,0,1-3.151-1.622c-.274-.192-.539-.36-.819-.6l-.413-.337-.3-.262-1.13-1.012a113.509,113.509,0,0,1-8.24-8.523c-2.59-2.951-5.022-5.943-7.387-9.124Z",
    transform: "translate(-59.094 -28.285)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2242",
    "data-name": "Path 2242",
    d: "M255.266,126.531l1.479,5.7-5.779-.325,1.31-6.353Z",
    transform: "translate(-78.05 -39.046)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2243",
    "data-name": "Path 2243",
    d: "M244.5,127.208l5.043-1.659-1.31,6.353s-4.457,1.3-6.055-1.955Z",
    transform: "translate(-75.317 -39.046)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2244",
    "data-name": "Path 2244",
    d: "M151.493,93.375c-1.043,3.595-2.143,7.2-3.259,10.781l-1.656,5.355-.794,2.654-.379,1.307-.32,1.192a10.942,10.942,0,0,0-.222,2.075c-.028.819-.012,1.689.025,2.571.085,1.772.225,3.6.415,5.433.376,3.668.829,7.416,1.282,11.12l-3.958,1a97.98,97.98,0,0,1-3.421-11.071c-.451-1.893-.87-3.807-1.171-5.8-.146-1-.272-2.016-.348-3.088a16.411,16.411,0,0,1,.092-3.578c.056-.4.1-.566.143-.835l.138-.744.292-1.449c.2-.954.418-1.9.639-2.834q.658-2.812,1.4-5.571c.978-3.691,2.047-7.327,3.227-10.961Z",
    transform: "translate(-42.804 -28.281)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2245",
    "data-name": "Path 2245",
    d: "M186.9,59.159c-.091.429.061.834.338.9s.577-.221.668-.65-.061-.834-.338-.9-.577.221-.668.65",
    transform: "translate(-58.118 -18.193)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2246",
    "data-name": "Path 2246",
    d: "M186.555,60.654a16.5,16.5,0,0,0,1.253,4.186,2.489,2.489,0,0,1-2.113-.127Z",
    transform: "translate(-57.751 -18.863)",
    fill: "#ed847e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2247",
    "data-name": "Path 2247",
    d: "M187.5,55.291a.258.258,0,0,0,.148-.469,2.528,2.528,0,0,0-2.333-.176.258.258,0,0,0,.2.477,2.02,2.02,0,0,1,1.841.121.255.255,0,0,0,.147.047",
    transform: "translate(-57.585 -16.932)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2248",
    "data-name": "Path 2248",
    d: "M165.075,61.439c-.48,5,.229,9.844-.891,14.193,0,0,1.244,4.036,8.636,4.036,8.129,0,3.73-4.035,3.73-4.035-4.478-1.06-4.49-4.351-3.837-7.443Z",
    transform: "translate(-51.061 -19.108)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2249",
    "data-name": "Path 2249",
    d: "M161.627,82.265c-.632-1.277-1.051-3.086.258-3.544,1.44-.5,9.133-.671,11.925.275a2.944,2.944,0,0,1,2.11,3.537Z",
    transform: "translate(-50.079 -24.355)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2250",
    "data-name": "Path 2250",
    d: "M139.76,347.155a6.968,6.968,0,0,1-1.464-.566.141.141,0,0,1,.019-.258c.242-.082,2.378-.787,2.94-.307a.448.448,0,0,1,.143.443.846.846,0,0,1-.455.657,1.8,1.8,0,0,1-1.183.032m-1.021-.664a2.866,2.866,0,0,0,2.078.381.573.573,0,0,0,.3-.453.171.171,0,0,0-.048-.181c-.292-.249-1.471-.006-2.333.253",
    transform: "translate(-42.986 -107.562)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2251",
    "data-name": "Path 2251",
    d: "M138.327,345.87a.14.14,0,0,1-.1-.18c.022-.07.555-1.705,1.357-2.1a.768.768,0,0,1,.624-.038.46.46,0,0,1,.351.462c-.03.674-1.487,1.667-2.162,1.851a.14.14,0,0,1-.07,0m1.722-2.068a.5.5,0,0,0-.343.045,3.387,3.387,0,0,0-1.112,1.65c.7-.311,1.665-1.093,1.683-1.492,0-.036.006-.121-.167-.185a.6.6,0,0,0-.061-.019",
    transform: "translate(-42.986 -106.831)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2252",
    "data-name": "Path 2252",
    d: "M194.33,353.163a6.98,6.98,0,0,1-1.555-.214.14.14,0,0,1-.042-.256c.216-.136,2.134-1.313,2.79-.976a.447.447,0,0,1,.241.4.846.846,0,0,1-.291.743,1.8,1.8,0,0,1-1.144.3m-1.147-.411a2.866,2.866,0,0,0,2.11-.108.574.574,0,0,0,.192-.511.171.171,0,0,0-.089-.165c-.342-.176-1.434.332-2.212.783",
    transform: "translate(-59.92 -109.366)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2253",
    "data-name": "Path 2253",
    d: "M192.807,352.325a.139.139,0,0,1-.076-.023.142.142,0,0,1-.064-.129c.006-.073.148-1.787.839-2.352a.771.771,0,0,1,.6-.181.459.459,0,0,1,.448.369c.125.662-1.063,1.964-1.678,2.3a.139.139,0,0,1-.068.017m1.2-2.409a.5.5,0,0,0-.323.123,3.386,3.386,0,0,0-.7,1.862c.611-.464,1.368-1.448,1.295-1.839-.007-.036-.023-.12-.206-.142a.494.494,0,0,0-.063,0",
    transform: "translate(-59.919 -108.736)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2254",
    "data-name": "Path 2254",
    d: "M183.588,347.542h5.438l.055-12.594h-5.438Z",
    transform: "translate(-57.096 -104.169)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2255",
    "data-name": "Path 2255",
    d: "M128.593,340.87l5.236.96,3.756-12.393-5.236-.959Z",
    transform: "translate(-39.992 -102.156)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2256",
    "data-name": "Path 2256",
    d: "M133.8,345.194l-5.946-1.406a.45.45,0,0,0-.522.258l-1.976,4.5a.834.834,0,0,0,.588,1.133c2.083.455,3.115.57,5.73,1.189,1.609.38,4.89,1.333,7.111,1.858,2.173.513,2.946-1.623,2.077-2.039-3.9-1.864-5.194-3.469-6.268-4.962a1.372,1.372,0,0,0-.794-.531",
    transform: "translate(-38.964 -106.914)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2257",
    "data-name": "Path 2257",
    d: "M188.1,352.313h-5.939a.452.452,0,0,0-.449.371l-.887,4.834a.825.825,0,0,0,.819.967c2.141-.037,5.232-.162,7.925-.162,3.149,0,4.27.172,7.963.172,2.232,0,2.765-2.257,1.822-2.462-4.29-.93-6.164-1.03-9.928-3.3a2.6,2.6,0,0,0-1.326-.424",
    transform: "translate(-56.234 -109.569)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2258",
    "data-name": "Path 2258",
    d: "M146.554,84.4c-5.305,5.063-6.883,16.423-6.883,16.423l9.587,4.7A81.909,81.909,0,0,0,154,93.285c1.907-6.672-3.606-12.55-7.442-8.89",
    transform: "translate(-43.438 -25.897)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160721",
    "data-name": "Group 160721",
    transform: "translate(103 66.007)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160720",
    "data-name": "Group 160720"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160719",
    "data-name": "Group 160719",
    clipPath: "url(#clip-path-18)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2259",
    "data-name": "Path 2259",
    d: "M154.373,95.8l-4.88,12.217,2.817,1.4s1.574-3.176,3.142-7.389Z",
    transform: "translate(-149.492 -95.801)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2260",
    "data-name": "Path 2260",
    d: "M183.306,107.477c-.04,6.07-.407,13.621-1.311,22.993H152.9c-.357-4.272,1.428-24.411-2.9-44.577a2.67,2.67,0,0,1,2.2-3.2,67.722,67.722,0,0,1,6.868-.738,107.488,107.488,0,0,1,12.363,0,55.515,55.515,0,0,1,8.423,1.51s2.488,2.695,3.242,15.331c.148,2.495.229,5.367.209,8.683",
    transform: "translate(-46.631 -25.431)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2261",
    "data-name": "Path 2261",
    d: "M157.558,81.842l-1.273.151a.377.377,0,0,0-.331.431c.4,2.593,3.7,18.055,28.223,40.633a.384.384,0,0,0,.642-.251l.1-1.43a.384.384,0,0,0-.124-.306c-24.7-22.585-26.664-36.392-26.811-38.873a.379.379,0,0,0-.424-.356",
    transform: "translate(-48.5 -25.452)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2262",
    "data-name": "Path 2262",
    d: "M180.459,124.788l11.166,10.736-1.291.812a5.494,5.494,0,0,1-5.637.127l-2.947-1.674a5.493,5.493,0,0,1-2.478-6.575Z",
    transform: "translate(-55.659 -38.809)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2263",
    "data-name": "Path 2263",
    d: "M186.482,138.269c.094.216.544.179,1-.083s.757-.649.663-.865-.545-.179-1.005.082-.756.649-.661.865",
    transform: "translate(-57.99 -42.663)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160724",
    "data-name": "Group 160724",
    transform: "translate(132.126 68.714)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160723",
    "data-name": "Group 160723"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160722",
    "data-name": "Group 160722",
    clipPath: "url(#clip-path-19)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2264",
    "data-name": "Path 2264",
    d: "M196.313,113.062c-1.76-3.213-4.955-9.66-4.5-13.332l4.3,4.649c.148,2.495.229,5.367.209,8.683",
    transform: "translate(-191.765 -99.73)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2265",
    "data-name": "Path 2265",
    d: "M185.069,89.121c-.46,5.158,11.289,17.647,11.289,17.647l9.418-7.671a60.7,60.7,0,0,0-8.8-11.477c-5.505-5.323-11.388-4.308-11.905,1.5",
    transform: "translate(-57.552 -26.169)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160727",
    "data-name": "Group 160727",
    transform: "translate(90.415 226.324)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160726",
    "data-name": "Group 160726"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160725",
    "data-name": "Group 160725",
    clipPath: "url(#clip-path-20)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2266",
    "data-name": "Path 2266",
    d: "M189.092,334.953l-.028,7h-5.44l.028-7Z",
    transform: "translate(-147.523 -330.494)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2267",
    "data-name": "Path 2267",
    d: "M133.165,328.481l5.238.96-1.938,6.387-5.238-.96Z",
    transform: "translate(-131.227 -328.481)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2268",
    "data-name": "Path 2268",
    d: "M166.239,50.149c-.8,5.355-1.532,8.439.532,11.812A7.02,7.02,0,0,0,179.2,61.3c2.126-4.455,3.072-12.464-1.6-15.855a7.091,7.091,0,0,0-11.362,4.705",
    transform: "translate(-51.449 -13.676)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2269",
    "data-name": "Path 2269",
    d: "M173.432,52.365c-.041,1.522-3.948,6.5-7.279,7.115-3.6.668-4.527-.349-5.1-5.264-.658-5.649-2.55-5.649-3.372-9.253-1.036-4.542,3.413-8.678,8.677-6.169,4.558,2.172,8.779-2.1,11.919-3.372s3.627,2.365,1.53,4.811c-2.073,2.419,1.216.943,2.18,1.975,1.727,1.851-1.1,6-8.152,7.649,1.211,1.3-.4,2.509-.4,2.509",
    transform: "translate(-48.992 -10.935)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2270",
    "data-name": "Path 2270",
    d: "M178.206,56.778a6.421,6.421,0,0,0,1.287,3.773c1.092,1.428,2.367.732,2.673-.846.276-1.42.041-3.874-1.348-4.739-1.369-.852-2.607.182-2.612,1.812",
    transform: "translate(-55.422 -16.999)",
    fill: "#ffc3bd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2271",
    "data-name": "Path 2271",
    d: "M165.256,152.452s-4.567,41.56-7.354,57.131c-3.052,17.05-18.858,70.57-18.858,70.57l-9.742-2.074s10.879-50.069,12.345-66.951c1.59-18.322,4.84-58.677,4.84-58.677Z",
    transform: "translate(-40.213 -47.413)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160730",
    "data-name": "Group 160730",
    transform: "translate(89.088 105.039)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160729",
    "data-name": "Group 160729"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160728",
    "data-name": "Group 160728",
    clipPath: "url(#clip-path-21)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2272",
    "data-name": "Path 2272",
    d: "M165.256,152.452s-4.567,41.56-7.354,57.131c-3.052,17.05-18.858,70.57-18.858,70.57l-9.742-2.074s10.879-50.069,12.345-66.951c1.59-18.322,4.84-58.677,4.84-58.677Z",
    transform: "translate(-129.301 -152.452)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2273",
    "data-name": "Path 2273",
    d: "M140.911,332.076c.041.009-1.658,3.557-1.658,3.557L128.292,333.3l.783-3.324Z",
    transform: "translate(-39.899 -102.623)",
    fill: "#263238"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160733",
    "data-name": "Group 160733",
    transform: "translate(116.529 119.792)",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160732",
    "data-name": "Group 160732"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160731",
    "data-name": "Group 160731",
    clipPath: "url(#clip-path-22)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2274",
    "data-name": "Path 2274",
    d: "M174.313,173.919c-7.082,1.4-5.3,28.012-3.912,41.7,1.684-9.675,3.978-28.293,5.526-41.507a2.474,2.474,0,0,0-1.614-.192",
    transform: "translate(-169.128 -173.863)"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2275",
    "data-name": "Path 2275",
    d: "M187.83,152.452s2.319,40.661,2.367,57.246c.051,17.25-3.794,73.732-3.794,73.732h-9.213s-2.48-55.474-3.544-72.415c-1.16-18.469-4.938-58.562-4.938-58.562Z",
    transform: "translate(-52.469 -47.413)",
    fill: "#407bff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_160736",
    "data-name": "Group 160736",
    transform: "translate(116.241 105.039)",
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160735",
    "data-name": "Group 160735"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_160734",
    "data-name": "Group 160734",
    clipPath: "url(#clip-path-23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2276",
    "data-name": "Path 2276",
    d: "M187.83,152.452s2.319,40.661,2.367,57.246c.051,17.25-3.794,73.732-3.794,73.732h-9.213s-2.48-55.474-3.544-72.415c-1.16-18.469-4.938-58.562-4.938-58.562Z",
    transform: "translate(-168.71 -152.452)",
    fill: "#fff"
  })))), /*#__PURE__*/React.createElement("path", {
    id: "Path_2277",
    "data-name": "Path 2277",
    d: "M191.335,337.224c.043,0-.372,3.825-.372,3.825H179.757l-.435-3.413Z",
    transform: "translate(-55.769 -104.877)",
    fill: "#263238"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyConversationIcon);
export default __webpack_public_path__ + "static/media/Empty-conversation-icon.c82bed80394d2007252f8d78b7cbc475.svg";
export { ForwardRef as ReactComponent };